module.exports = __webpack_public_path__ + "img/az_online.fbe87d04.png";